export default __webpack_public_path__ + "static/media/fp_logo_hr.881234bd.png";